import { atom } from "@reatom/framework";
import { OrdersInfoDto } from "definitions/poizon-bff";

import { getClientsCount, getOrdersInfo, getTokensCount } from "../fetchers";

export interface statCardsDto {
  ordersInfo?: OrdersInfoDto | null;
  tokensCount: number;
  clientsCount: number;
  clientsCountLoading: boolean;
  tokensCountLoading: boolean;
  ordersInfoLoading: boolean;
}

export const statCardsAtom = atom<statCardsDto>((ctx) => {
  const ordersInfo = ctx.spy(getOrdersInfo.dataAtom);
  const tokensCount = ctx.spy(getTokensCount.dataAtom);
  const clientsCount = ctx.spy(getClientsCount.dataAtom);

  const clientsCountLoading = ctx.spy(getClientsCount.isLoadingAtom);
  const tokensCountLoading = ctx.spy(getTokensCount.isLoadingAtom);
  const ordersInfoLoading = ctx.spy(getOrdersInfo.isLoadingAtom);

  return {
    ordersInfo,
    tokensCount,
    clientsCount,
    clientsCountLoading,
    tokensCountLoading,
    ordersInfoLoading,
  };
}, "statCardsAtom");
